import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de'

class FormDate {
  private dateInputs: [] | NodeListOf<HTMLInputElement>

  constructor () {
    this.dateInputs = document.querySelectorAll('[data-form-date]')
  }

  public init (): void {
    this.dateInputs.forEach((input: HTMLInputElement): void => {
      // TYPO3 maps the "Date" form element with the RFC 3339 full-date format, so the
      // submitted value has to stay ISO while the visitor sees the localised one.
      const datepicker = flatpickr(input, {
        allowInput: true,
        altFormat: input.getAttribute('data-datepicker-format'),
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: German
      })

      this.moveLabelReferences(input, datepicker.altInput)
    })
  }

  private moveLabelReferences (input: HTMLInputElement, altInput: HTMLInputElement | undefined): void {
    if (typeof altInput === 'undefined') {
      return
    }

    const describedBy = input.getAttribute('aria-describedby')

    if (describedBy !== null) {
      altInput.setAttribute('aria-describedby', describedBy)
      input.removeAttribute('aria-describedby')
    }

    if (input.id !== '') {
      altInput.id = `${input.id}-visible`
      document.querySelector(`label[for="${input.id}"]`)?.setAttribute('for', altInput.id)
    }
  }
}

const formDate = new FormDate()
formDate.init()
